// Servizi dominio ESPERIENZE / EVENTI (biglietteria) area stakeholder.
// Riusa l'istanza axios centrale (lib/api.js) tramite ./client.
import { api, unwrap } from './client';

const g = (path, params, config) => unwrap(api.get(path, { params, ...(config || {}) }));
const p = (path, body, config) => unwrap(api.post(path, body, config));
const u = (path, body, config) => unwrap(api.put(path, body, config));
const d = (path, config) => unwrap(api.delete(path, config));

export const experienceService = {
  options: () => g('/experience/options'),
  dashboard: () => g('/experience/dashboard'),
  analytics: (days = 30) => g('/experience/analytics', { days }),
  list: (params) => g('/experience/experiences', params),
  get: (id) => g(`/experience/experiences/${id}`),
  create: (body) => p('/experience/experiences', body),
  update: (id, body) => u(`/experience/experiences/${id}`, body),
  setStatus: (id, body) => p(`/experience/experiences/${id}/status`, body),
  duplicate: (id) => p(`/experience/experiences/${id}/duplicate`),
  remove: (id) => d(`/experience/experiences/${id}`),
  pricePreview: (body) => p('/experience/price-preview', body),

  // ---- Attivazione modulo (self-service stakeholder + approvazione admin) ----
  moduleStatus: () => g('/experience/module'),
  activateModule: () => p('/experience/module/activate'),
  moduleRequests: (status) => g('/experience/admin/module-requests', status ? { status } : {}),
  decideModule: (ownerId, approve, note) => p(`/experience/admin/module-requests/${ownerId}/decide`, { approve, note }),

  // ---- Catalogo pubblico + checkout ----
  publicList: (params) => g('/experience/public/experiences', params),
  publicGet: (idOrSlug) => g(`/experience/public/experiences/${idOrSlug}`),
  publicReviews: (id, limit = 30) => g(`/experience/public/experiences/${id}/reviews`, { limit }),
  crmReviews: () => g('/experience/reviews'),
  checkout: (body) => p('/experience/public/checkout', body),
  // Checkout Stripe reale (Payment Element, anche ospite senza login)
  checkoutIntent: (body) => p('/experience/public/checkout/intent', body),
  checkoutConfirm: (orderId) => p('/experience/public/checkout/confirm', { order_id: orderId }),

  // ---- Vetrina / Live Page (storefront organizzatore) ----
  getStorefront: () => g('/experience/storefront'),
  updateStorefront: (body) => u('/experience/storefront', body),
  publicStorefront: (ownerId) => g(`/experience/public/storefront/${ownerId}`),

  // ---- Locandina social (poster) ----
  getPosterBlob: (eid, format = 'story', sessionId) =>
    g(`/experience/experiences/${eid}/poster.png`, { format, session_id: sessionId || undefined }, { responseType: 'blob' }),

  // ---- Check-in & Partecipanti ----
  checkin: (code) => p('/experience/checkin', { code }),
  participants: (eid, params) => g(`/experience/experiences/${eid}/participants`, params),
  participantsCsvBlob: (eid, sessionId) =>
    g(`/experience/experiences/${eid}/participants.csv`, { session_id: sessionId || undefined }, { responseType: 'blob' }),
  participantsPdfBlob: (eid, sessionId) =>
    g(`/experience/experiences/${eid}/participants.pdf`, { session_id: sessionId || undefined }, { responseType: 'blob' }),
};

// URL assoluti per download/immagini generati dal backend (usati in <img> o download).
const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
export const experiencePosterUrl = (eid, format = 'story', sessionId = '') =>
  `${BACKEND}/api/experience/experiences/${eid}/poster.png?format=${format}${sessionId ? `&session_id=${encodeURIComponent(sessionId)}` : ''}`;
export const experienceParticipantsCsvUrl = (eid, sessionId = '') =>
  `${BACKEND}/api/experience/experiences/${eid}/participants.csv${sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : ''}`;
export const experienceParticipantsPdfUrl = (eid, sessionId = '') =>
  `${BACKEND}/api/experience/experiences/${eid}/participants.pdf${sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : ''}`;

// URL assoluto dell'immagine QR (per <img src>). Codifica solo il codice biglietto.
export const experienceQrUrl = (code) => `${BACKEND}/api/experience/public/qr/${encodeURIComponent(code)}.png`;

// URL assoluto della ricevuta PDF (non fiscale) di un ordine esperienza.
export const experienceReceiptUrl = (code) => `${BACKEND}/api/experience/public/orders/${encodeURIComponent(code)}/receipt.pdf`;
